import React, { useEffect } from "react";
import "../Styles/Home.css";
import Footer from "../Comp/Footer";
import Header from "../Comp/Header";
import AOS from "aos";
import "aos/dist/aos.css";
import ProjectSlider from "../Comp/skillslider";
import { FaGithub } from "react-icons/fa";
import { GrMail } from "react-icons/gr";

const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 1750,
      once: true,
    });
  }, []);

  return (
    <div className="home">
      <Header />
      <div className="home-content">
        <h1 data-aos="fade-up">Welcome to my website!</h1>
        <p1 data-aos="fade-up">
          Welcome to my personal website! I approached with a mobile design
          concept that was attention grabbing, yet simple and not overwhelming.
          I built the rest from there! I enjoy working on projects like this
          webpage as a hobby. The conquest to learn new concepts is
          never-ending. If you like this website and need a small one built for
          your needs, reach out to me!
        </p1>
        <h2 data-aos="fade-up"> About the website</h2>
        <p2 data-aos="fade-up">
          This website was created with HTML, CSS and the JavaScript library,
          React. It is being hosted on Amazon Web Services (AWS). All of the
          code is on GitHub as a private repository. My full work and
          educational history can be viewed on the 'Résumé' tab in the side
          menu. Highlighted skills can be viewed below. From coding, custom
          builds, and interpersonal skills! Also, feel free to check out my
          number generator game, or my recipe finder app. Enjoy your stay!
        </p2>
      </div>
      <div className="projects">
        <ProjectSlider />
        <div className="socials">
          <h1 data-aos="fade-in">On the Web</h1>
          <div className="social-links">
            <a
              data-aos="fade-up"
              href="https://github.com/pauldjoplin"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub />
            </a>

            <a data-aos="fade-up" href="mailto:pdjnetwork95@gmail.com">
              <GrMail />
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
export default Home;
